<div class="container-fluid ter-container">
    <reports-layout></reports-layout>
</div>